var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box annual-usage"},[_c('details-box-heading',{attrs:{"label":"Annual Usage"}}),_c('div',{staticClass:"box-content mb-2"},[_c('details-numeric-input',{attrs:{"field":"annual_usage","component":_vm.components.annual_usage.annual_usage},on:{"change":_vm.updateMasterData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }